//** NEW TEMPLATE
import React, { useEffect, useState, useCallback, useRef } from "react";
import { injectIntl } from "react-intl";
import { withRouter, Link } from "react-router-dom";
import Routes from "../../Routes";

// REDUX
import { useSelector, useDispatch } from "react-redux";
import ACTIONS from "../../actions/types";

// HOC
import NewAppHOC from "../../hoc/NewAppHOC";

// COMPONENTS
import MainAsideNav from "../../components/navigations/MainAsideNav";
import HelperAsideNav from "../../components/navigations/HelperAsideNav";
import Main from "../../components/main/Main";
import ReviewCard from "../../components/display/ReviewCard";
import MainNav from "../../components/navigations/MainNav";
import ToggleLayout from "../../components/layout/ToggleLayout";
import AnimateLayout from "../../components/layout/AnimateLayout";
import Title from "../../components/text/Title";
import Message from "../../components/alerts/Message";
import Layout from "../../components/layout/Layout";
import Icon from "../../components/icons/Icon";

// FUNCTIONS
import AJAX from "../../functions/ajax";
import ParseHTML from "../../functions/ParseHTML";
import validateData from "../../functions/validateData";

// DATA MODEL
import stageDataModel from "../../data_model/reviewer/stage/stage_data";
import stagesDataModel from "../../data_model/reviewer/dashboard/stages";

function ReviewStage({ match, intl }) {
  const isInitialMount = useRef(false);
  const _id = 354980982420984;
  const dispatch = useDispatch();

  const [counterData, setCounterData] = useState();
  const [allStages, setAllStages] = useState();
  const [activeReviewStage, setReviewStageActive] = useState();
  const reduxState = useSelector(state => state);

  const getMenuData = () => {
    AJAX()
      .getReviewStages(_id, reduxState)
      .then(res => {
        const isMenuDataValid = validateData(
          "Reviewer > Stage > AJAX().getReviewStages",
          res,
          stagesDataModel
        );
        if (isMenuDataValid) {
          removeUpcomingStages(res.data);
          setAllStages(res.data.stages);
        }
      });
  };

  const getMainData = () => {
    AJAX()
      .getReviewStage(_id, reduxState, match.params.id)
      .then(res => {
        // validate the stage data
        const isStageDataValid = validateData(
          "Reviewer > Stage > AJAX().getReviewStage",
          res,
          stageDataModel
        );

        if (isStageDataValid) {
          setReviewStageActive(res.data.stage);

          dispatch({
            type: ACTIONS.SET_PAGE_IDS,
            payload: { stage: res.data.stage.id },
          });

          setCounterData({
            active: res.data.stage.in_range == 0 ? true : false,
            end_at: res.data.stage.end_at, //new Date().setSeconds(new Date().getSeconds() + 10), //res.data.stage.end_at,
            start_at: res.data.stage.start_at,
            toWhat: intl.formatMessage({ id: "end" }),
          });
        }
      });
  };

  const init = useCallback(() => {
    getMenuData();
    getMainData();
  }, [getMenuData, getMainData]);

  // run once on page load
  useEffect(init, []);

  // on route change
  useEffect(() => {
    if (isInitialMount.current) {
      getMainData();
    } else {
      isInitialMount.current = true;
    }
  }, [match]);

  const removeUpcomingStages = stagesData => {
    const stageData = JSON.parse(JSON.stringify(stagesData));
    stageData.stages = stageData.stages.filter(i => i.in_range != "-1");
    return stageData;
  };

  const handleNavItemClick = () => {
    dispatch({ type: ACTIONS.HIDE_MAIN_MENU_ON_TOP });
  };

  const handleCounterEnd = () => {
    getMainData();
  };

  // run on unmount
  useEffect(() => {
    return () => {
      AJAX().cancelRequest(_id);
    };
  }, [_id]);

  return (
    <NewAppHOC>
      <MainAsideNav>
        {/* <AnimateLayout animate={activeReviewStage && allStages} addClass="__n_bs"> */}
        <div className="__n_bs">
          <Link to="/ui/reviewer/dashboard">
            <Layout flex>
              <div>
                <Icon
                  iconId="reviewCaseFull"
                  addClass="c1 __n_bi"
                  style={{ marginRight: ".7rem" }}
                />
              </div>
              <Title tagName="h1" addClass="c16" removeWeight>
                {intl.formatMessage({ id: "reviewerDashboard" })}
              </Title>
            </Layout>
          </Link>
          {activeReviewStage && (
            <div>
              <Link to={`/ui/reviewer/stage/${activeReviewStage.id}`}>
                <Layout flex>
                  <div>
                    <Icon
                      iconId="categoriesFull"
                      addClass="c1 __n_bi"
                      style={{ marginRight: ".7rem" }}
                    />
                  </div>
                  <Title tagName="h1" addClass="c16">
                    {activeReviewStage.title}
                  </Title>
                </Layout>
              </Link>
              <ParseHTML html={activeReviewStage.description} />
            </div>
          )}
          {allStages && (
            <MainNav
              clicked={handleNavItemClick}
              title={intl.formatMessage({ id: "stages" })}
              data={allStages}
              linkTo={Routes.reviewerStage().path}
              activeItem={match.params.id}
            />
          )}
        </div>
        {/* </AnimateLayout> */}
      </MainAsideNav>
      <Main counter={counterData} onCounterEnd={handleCounterEnd}>
        {/* <AnimateLayout animate={activeReviewStage}> */}
        {activeReviewStage && (
          <ToggleLayout
            id="986436795436"
            title={activeReviewStage.title}
            hideBtns={activeReviewStage.collections.length === 0}
          >
            {activeReviewStage.collections.length > 0 ? (
              activeReviewStage.collections.map(stage => {
                // set the background color of the collection based on parent status
                stage.in_range = activeReviewStage.in_range;

                return (
                  <ReviewCard
                    popoverStatsFor="collection"
                    key={stage.id}
                    data={stage}
                    hideFooter
                    clickTarget={Routes.reviewerCollection().path}
                  />
                );
              })
            ) : (
              <Message msg={intl.formatMessage({ id: "noCollectionInStage" })} />
            )}
          </ToggleLayout>
        )}
        {/* </AnimateLayout> */}
      </Main>
      <HelperAsideNav />
    </NewAppHOC>
  );
}

export default injectIntl(withRouter(ReviewStage));
